import createLucideIcon from '../createLucideIcon';

const ArrowUpRight = createLucideIcon('ArrowUpRightIcon', [
  ['line', { x1: '7', y1: '17', x2: '17', y2: '7', key: '16hgw2' }],
  ['polyline', { points: '7 7 17 7 17 17', key: 'blehsp' }],
]);

export default ArrowUpRight;
